import Vue from 'vue'
import Router from 'vue-router'
import Home from './pages/home.vue'
import Index from './pages/index.vue'
import Sound from './pages/sound.vue'
import Sound2 from './pages/sound2.vue'
import Login from './pages/login.vue'
import Register from './pages/register.vue'
import Pay from './pages/pay.vue'
import Xy from './pages/xy.vue'
import Xy2 from './pages/xy2.vue'
import Xy3 from './pages/xy3.vue'
import Info from './pages/info.vue'

Vue.use(Router)

export default new Router({
  routes: [
    // 根路由
    {
      path: '/',
      name: 'home',
      component: Home,
      redirect: '/index',
      children: [
        // 首页
        {
          path: '/index',
          name: 'idnex',
          component: Index,

        },
        // 详情页
        {
          path: '/sound/:id',
          name: 'sound',
          component: Sound,

        },
         // 详情页
         {
          path: '/sound2/:id',
          name: 'sound2',
          component: Sound2,

        },
        // 注册协议
        {
          path: '/xy',
          name: 'xy',
          component: Xy
        },
        {
          path: '/xy2',
          name: 'xy2',
          component: Xy2
        },
        {
          path: '/info',
          name: 'info',
          component: Info
        },
        // 登录
        {
          path: '/login',
          name: 'login',
          component: Login,
        },
        // 注册
        {
          path: '/register',
          name: 'register',
          component: Register,
        },
        // 支付页
        {
          path: '/pay',
          name: 'pay',
          component: Pay,
        },
        {
          path: '/xy3',
          name: 'xy3',
          component: Xy3,
        }

      ]
    },

  ]
})